const steps = [
  {
    num: '01',
    icon: 'ri-search-eye-line',
    title: 'Evaluate System',
    desc: 'We assess your current system performance and property needs to understand exactly what\'s required — no guesswork.',
    image: 'https://public.readdy.ai/ai/img_res/fe3510f648d459b1e0d0493d8202348e.jpg',
  },
  {
    num: '02',
    icon: 'ri-file-list-3-line',
    title: 'Recommend Solution',
    desc: 'Clear options with honest pricing. No unnecessary upsells, no hidden fees — just straightforward recommendations.',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20technician%20showing%20homeowner%20tablet%20with%20service%20recommendations%20professional%20consultation%20living%20room%20friendly%20conversation%20clean%20uniform%20residential%20interior&width=400&height=280&seq=proc-rec-001&orientation=landscape',
  },
  {
    num: '03',
    icon: 'ri-settings-3-line',
    title: 'Perform Service',
    desc: 'Installation or repair completed with precision by our certified technicians. Done right the first time.',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20technician%20installing%20air%20conditioning%20unit%20professional%20tools%20working%20residential%20home%20exterior%20clean%20precise%20installation%20sunny%20day%20photography&width=400&height=280&seq=proc-svc-001&orientation=landscape',
  },
  {
    num: '04',
    icon: 'ri-customer-service-2-line',
    title: 'Ongoing Support',
    desc: 'Long-term system performance through scheduled maintenance and responsive 24/7 support whenever you need us.',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20technician%20performing%20annual%20maintenance%20check%20air%20conditioning%20system%20residential%20home%20professional%20service%20clean%20equipment%20tools%20bright%20daylight%20photography&width=400&height=280&seq=proc-sup-001&orientation=landscape',
  },
];

export default function Process() {
  return (
    <section className="bg-gradient-to-br from-[#0a1628] via-[#0d1b2a] to-[#111827] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">How It Works</span>
          <h2
            className="text-4xl md:text-5xl font-bold text-white mt-3"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            A Clear, Professional Approach
          </h2>
          <p className="text-[#9ca3af] text-lg mt-3 max-w-lg mx-auto">
            From first call to long-term comfort — here&apos;s exactly what to expect.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative group">
              {/* Connector */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-[140px] left-[calc(100%+12px)] w-[calc(100%-24px)] h-px bg-gradient-to-r from-[#00d4ff]/30 to-transparent z-10" />
              )}
              <div className="bg-[#1a2535]/80 border border-white/8 rounded-2xl overflow-hidden h-full hover:border-[#00d4ff]/30 transition-all duration-300 hover:-translate-y-1">
                {/* Step image */}
                <div className="w-full h-40 overflow-hidden">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  {/* Number + Icon row */}
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#00d4ff] text-[#0a1628] font-bold text-sm shrink-0" style={{ fontFamily: 'Outfit, sans-serif' }}>
                      {step.num}
                    </div>
                    <div className="w-7 h-7 flex items-center justify-center">
                      <i className={`${step.icon} text-[#00d4ff] text-lg`} />
                    </div>
                  </div>
                  <h3 className="text-white font-bold text-lg mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {step.title}
                  </h3>
                  <p className="text-[#9ca3af] text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
